import React from 'react';
import { makeStyles, styled } from '@material-ui/styles';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import PanelButtons from './PanelButtons';
import { Switch } from '@material-ui/core';
import { useState, useRef } from 'react'
import SelectAddress from './SelectAddress';
import TopAppBar from './TopAppBar';
import { getDeliveryFees } from '../hooks/orders-fees';
import { formatCurrency, priceFormat } from '../hooks/currency';
import { getLabelNormalDelivery, getLabelExtraDelivery } from '../hooks/orders-format';
import { getTotalOrder, getTotalPriceVariant } from '../hooks/price';
import { getOptionPrice, getOptionText } from '../hooks/additions';



const useStyles = makeStyles((theme) => ({

  contentPage: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: "300px",
    [theme.breakpoints.up('md')]: {
      width: "50%",
      marginLeft: "25%",
      padding: theme.spacing(2),
    },
  },
  table: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(1),
  },

  divider: {
    margin: theme.spacing(0, 2)
  },

  pageTitle: {
    fontSize: '1.5rem',
    textAlign: 'start',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
    textTransform: "uppercase",

    [theme.breakpoints.up('md')]: {
      paddingTop: "10vh",
    },
  },

  price: {
    margin: theme.spacing(0, 0, 0, 2),
    fontSize: "2rem",
  },


  delivery: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: theme.spacing(0.5, 4, 0.5, 4),
  },

  orderType: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: theme.spacing(1.5),
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    backgroundColor: theme.palette.background.grey,
    borderRadius: "0.5rem",
    padding: theme.spacing(1),
  },


  total: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing(1),
    marginRight: theme.spacing(3),
  },


  containerButtons: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    [theme.breakpoints.up('md')]: {
      //bottom: "10vh",
      left: "30%",
      width: "40%",
      padding: theme.spacing(2),
    },
    //backgroundColor:"blue",
  },

  paddiFooter: {
    paddingBottom: "30vh",
    //backgroundColor:"blue",
  },



  infoBox: {
    backgroundColor: theme.palette.background.warnning,
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    borderRadius: "0.5rem",
    padding: theme.spacing(2),
  },


  cellName: {
    display: 'flex',
    flexDirection: 'column',
  },

  contentOption: {
    display: 'flex',
    flexDirection: 'row',
  },

  listOptions: {

    display: 'flex',
    flexDirection: 'column',
    // backgroundColor: 'blue',
  },

}));



export default function CheckoutPage(props) {

  const classes = useStyles();
  const {
    order,
    store,
    strings,
    onOrderChecked,
    onNeedsPickup,
    onNeedsAddress,
    onBack,
    onEditPickup,
    onEditAddress,
  } = props;

  //console.debug(" CheckoutPage:", order); 

  const currency = store.currency;

  const toCurrencyNoSymbol = (value) => {
    return (currency) ?
      priceFormat(currency.style, value, false) :
      value
  }

  const costumerPlace = order.fullAddress ? order.fullAddress.geopoint : undefined;
  const pickupGeopoint = order.pickupAddress ? order.pickupAddress.geopoint : undefined;
  const defaultDelivery = getDeliveryFees(store, pickupGeopoint, costumerPlace);

  const refDelivery = useRef(defaultDelivery);
  refDelivery.current = defaultDelivery;

  const [orderType, setOrderType] = useState(order.type ? order.type : "delivery");

  const value = getTotalOrder(order, refDelivery.current);
  const [totalPrice, setTotalPrice] = useState(formatCurrency(currency, value, false))

  const [showLocationStore, setShowLocationStore] = useState(null)



  //console.debug("CheckOut: order", order);


  const handlerChangeSwitch = () => {
    const type = orderType == "takeaway" ? "delivery" : "takeaway";
    setOrderType(type);
    const newOrder = {
      ...order
    };
    newOrder.type = type;
    newOrder.deliveryPrice = refDelivery.current
    const total = getTotalOrder(newOrder, refDelivery.current)
    setTotalPrice(formatCurrency(currency, total));
  }



  const handlerOnNext = (order) => {
    const newOrder = {
      ...order,
    };
    newOrder.type = orderType;
    newOrder.deliveryPrice = refDelivery.current
    const total = getTotalOrder(newOrder, refDelivery.current);
    newOrder.totalPrice = parseFloat(total).toFixed(2);
    //console.debug('CheckOut:  handlerOnNext');


    if (newOrder.type === "takeaway" || newOrder.type ==="AUTO") {
      if (onOrderChecked)
        onOrderChecked(newOrder);
      return;
    }

    if (!newOrder.pickupAddress) {
      //console.debug('CheckOut:  onNeedsPickup');
      onNeedsPickup(newOrder);
      return;
    }


    if (refDelivery.current.status == 'disable') {
      onOrderChecked(newOrder);
      return;
    }

    if (!newOrder.fullAddress) {
      //console.debug('CheckOut: onNeedsAddress');
      onNeedsAddress(newOrder);
      return;
    }

    const deliveryPrice = refDelivery.current;
    if (isCheckoutOK()) {
      newOrder.deliveryPrice = deliveryPrice;
      //console.debug('CheckOut: Checkout ok');
      onOrderChecked(newOrder);
    } else {
      //console.debug('CheckOut: out of range');
    }
  }

  const handlerOnClickEditAddress = () => {
    if (onEditAddress) {
      //console.debug('CheckOut: handlerOnClickEditAddress');
      onEditAddress();
    }
  }
  const handlerOnClickEditPickup = () => {
    if (onEditPickup) {
      //console.debug('CheckOut: handlerOnClickEditPickup');
      onEditPickup();
    }
  }

  const isCheckoutOK = () => {
    const delivery = refDelivery.current.status == 'ok' || refDelivery.current.status == 'extra'
    return order.fullAddress && delivery;
  }

  const getDisplayVariant = (options) => {
    return options.map((option, index) => (
      <div className={classes.contentOption} key={index}>
        <Typography variant="body2" color="textPrimary">
          {getOptionText(option) + " " + getOptionPrice(currency, option)}
        </Typography>

      </div>
    ))
  }



  const displaySummary = (list) => {
    let display = [];

    for (let i = 0, k = 0; i < list.length; i++) {
      const item = list[i];
      if (!item.variants || item.variants.length == 0) {
        display.push({ ...item });
      } else {

        const itemVariants = item.variants.map((it) => {
          const newItem = { ...item };
          newItem.price = getTotalPriceVariant(item, it.options);
          newItem.count = 1;
          newItem.variants = undefined;
          newItem.displayVariants = getDisplayVariant(it.options);
          return newItem;
        })
        itemVariants.forEach(element => {
          display.push(element);
        });
      }
    }
    //console.debug(' displaySummary', display);
    return display;
  }




  const table = (
    <Table aria-label="simple table" padding='none'>

      <TableBody className={classes.table} >
        {
          displaySummary(order.list).map((row, index) => (
            <TableRow key={index} >
              <TableCell align="left" >{row.count + "x"}</TableCell>
              <TableCell component="td" scope="row" padding='normal'>
                <div className={classes.cellName}>
                  <Typography variant="subtitle2" color="textPrimary">{row.name}</Typography>

                  <div className={classes.listOptions}>
                    {row.displayVariants}
                  </div>
                </div>
              </TableCell>
              <TableCell align="right">{toCurrencyNoSymbol(row.price * row.count)}</TableCell>
            </TableRow>
          ))}

        {orderType == "delivery" && refDelivery.current.status != 'disable' &&
          <TableRow>
            <TableCell colSpan={2} padding='normal'>
              <Typography variant="body2" color="textPrimary">
                {getLabelNormalDelivery(refDelivery.current, strings)}
              </Typography>
            </TableCell>
            <TableCell align="right" padding='none'>{toCurrencyNoSymbol(refDelivery.current.normalPrice)}</TableCell>
          </TableRow>
        }

        {orderType == "delivery" && refDelivery.current.status != 'disable' && refDelivery.current.extraPrice &&
          <TableRow>
            <TableCell colSpan={2} padding='normal'>
              <Typography variant="body2" color="textPrimary">
                {getLabelExtraDelivery(refDelivery.current, strings)}
              </Typography>
            </TableCell>
            <TableCell align="right" padding='none'>{toCurrencyNoSymbol(refDelivery.current.extraPrice)}</TableCell>
          </TableRow>
        }

      </TableBody>
    </Table>
  )

  const body = (

    <TableContainer>

      <div className={classes.table}>
        {table}
      </div>


      <div className={classes.total}>
        <Typography variant="body1"> {strings.total}: </Typography>
        <p className={classes.price}> {totalPrice}</p>
      </div>

      <Divider className={classes.divider} />

    </TableContainer>
  )


  return (
    <div className={classes.contentPage}>

      <TopAppBar
        title={strings.title_summary}
      />

      {store.isDemo &&
        <div className={classes.infoBox}>
          <Typography variant="body1">
            {strings.order_demo_info}
          </Typography>
        </div>
      }

      {
        (orderType === "delivery" || orderType === "takeaway") &&
        <div className={classes.orderType}>
          {!store.disableDelivery && !store.disableTakeaway &&
            <Switch
              checked={orderType == "delivery"}
              onChange={handlerChangeSwitch}
              name="checkedB"
              color="accent"
            />
          }
          {
            orderType == "delivery" ?
              <Typography variant="body1"> {strings.order_delivery}</Typography>
              : <Typography variant="body1"> {strings.order_takeaway}</Typography>
          }
        </div>
      }

      {
        (orderType === "AUTO") &&
        <div className={classes.orderType}>
            <Typography variant="body1"> {strings.order_local}</Typography>
        </div>
      }


      {orderType == "takeaway" &&
        <SelectAddress
          title={store.name}
          icon={"store"}
          fullAddress={order.pickupAddress}
          onClickEdit={null}
        />
      }

      {orderType == "delivery"
        && refDelivery.current.status != 'disable'
        && !store.pickupService
        && store.disableTakeaway
        && !showLocationStore &&
        <SelectAddress
          title={" "}
          icon={"store"}
          fullAddress={{ address: store.name }}
          onClickEdit={null}
          onClickStoreIcon={() => { setShowLocationStore(true) }}
        />
      }

      {orderType == "delivery"
        && refDelivery.current.status != 'disable'
        && !store.pickupService
        && store.disableTakeaway
        && showLocationStore &&

        <SelectAddress
          title={store.name}
          icon={"store"}
          fullAddress={order.pickupAddress}
          onClickEdit={null}
          onClickStoreIcon={() => { setShowLocationStore(false) }}
        />
      }

      {orderType == "delivery"
        && refDelivery.current.status != 'disable'
        && store.pickupService &&

        <SelectAddress
          title={strings.pickup_address}
          icon={"store"}
          fullAddress={order.pickupAddress}
          onClickEdit={handlerOnClickEditPickup}
        />
      }

      {
        orderType == "delivery"
        && refDelivery.current.status != 'disable'
        && order.fullAddress &&
        <SelectAddress
          title={strings.delivery_address}
          fullAddress={order.fullAddress}
          onClickEdit={handlerOnClickEditAddress}
          icon={"flag"}
        />
      }

      {body}

      <div className={classes.paddiFooter}>

      </div>

      <PanelButtons
        labelCancel={strings.action_back}
        labelNext={
          orderType == "delivery" && isCheckoutOK() ?
            strings.action_confirm : strings.action_next
        }
        onClickCancel={onBack}
        onClickNext={() => handlerOnNext(order)}
      />
    </div>
  );
}